export default {
  barley: {
    gas: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 17,
      baselineElectricalDryer: 1.5,
    },
    kerosene: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 16.6,
      baselineElectricalDryer: 1.5,
    },
    naturalGas: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 12.5,
      baselineElectricalDryer: 1.5,
    },
    lpg: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 14.8,
      baselineElectricalDryer: 1.5,
    },
    aerated: {
      baselineStartingMC: 17,
      baselineEndMC: 16,
      moistureChange: 1.0,
      baselineThermalDryer: null,
      baselineElectricalDryer: null,
    },
    adesco: {
      baselineStartingMC: 18.5,
      baselineEndMC: 18.0,
      moistureChange: 0.5,
      baselineThermalDryer: null,
      baselineElectricalDryer: null,
    },
  },
  wheat: {
    gas: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 17,
      baselineElectricalDryer: 1.5,
    },
    kerosene: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 16.6,
      baselineElectricalDryer: 1.5,
    },
    naturalGas: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 12.5,
      baselineElectricalDryer: 1.5,
    },
    lpg: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 14.8,
      baselineElectricalDryer: 1.5,
    },
    aerated: {
      baselineStartingMC: 17,
      baselineEndMC: 16,
      moistureChange: 1.0,
      baselineThermalDryer: null,
      baselineElectricalDryer: null,
    },
    adesco: {
      baselineStartingMC: 18.5,
      baselineEndMC: 18.0,
      moistureChange: 0.5,
      baselineThermalDryer: null,
      baselineElectricalDryer: null,
    },
  },
  beans: {
    gas: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 34,
      baselineElectricalDryer: 3,
    },
    kerosene: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 33.2,
      baselineElectricalDryer: 3,
    },
    naturalGas: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 25,
      baselineElectricalDryer: 3,
    },
    lpg: {
      baselineStartingMC: 18.5,
      baselineEndMC: 14,
      moistureChange: 4.5,
      baselineThermalDryer: 29.6,
      baselineElectricalDryer: 3,
    },
    aerated: {
      baselineStartingMC: null,
      baselineEndMC: null,
      moistureChange: null,
      baselineThermalDryer: null,
      baselineElectricalDryer: null,
    },
    adesco: {
      baselineStartingMC: 18.5,
      baselineEndMC: 18.0,
      moistureChange: 0.5,
      baselineThermalDryer: null,
      baselineElectricalDryer: null,
    },
  },
};
